<!-- provide an array of btnConfig arrays
	[
		symbol		= string that will appear on the button
		code		= string that will be returned when the button is clicked
		enabled		= 1  disabled = 0
		selected	= 1  unselected = 0  apply selected class or not
	]
a button will be created for each item in the array -->

<template>

	<div class="button-container">
		<template v-for="(b) in btnConfig">
			<!-- ALLOWS FOR USE OF ICON NAME IN ARRAY POSITION 4 -->

			<!-- THIS (array b[4] is not provided) -->
			<button class="button" v-if="b[4]==undefined"
				:disabled="!b[2] || isDisabled"
				:class="{selected:b[3], hover:b[2] && !isDisabled}"
				type="button"
				v-text="b[0]"
				v-on:click.stop="toolPick(b[1])"
				v-bind:key="b.ID"
			/>

			<!-- OR THIS (file.png provided in position b[4] -->
			<button class="button" v-if="b[4]!==undefined"
				:disabled="!b[2] || isDisabled"
				:class="{selected:b[3], hover:b[2] && !isDisabled}"
				type="button"
				v-on:click.stop="toolPick(b[1])"
				v-bind:key="b.ID"
			>
				<img class="button-image" :src="require('../assets/' + b[4])" v-bind:class="{disabled:!b[2] || isDisabled}"/>	
			</button>

		</template>
	</div>
</template>

<script>
	export default {
		name: 'BranchButtons',
		components:{},
		props:{
			btnConfig:{
				// [symbol,code,visibility,selected]
				type:Array,
				required:false // allow this component to render before the prop is available
			},
			isDisabled:{
				type:Boolean,
				required:false,
				default:false
			}
		},
		data() {return {}},
		apollo:{},
		methods:{
			toolPick(branchToolCode){
				// console.log ('toolPick' , branchToolCode)
				let vars = ({branchToolCode:branchToolCode})
				this.$emit('branchToolCode',vars)
			},
		}
	}
</script>

<style scoped>

	*{
		padding: 0;
	}

	.button-container{
		height: 24px;
	}
		.button {
			align-items: center;
			background-color: #f0f0f0;
			display: inline-flex;
			justify-content: center;
			height: inherit;
			min-width: 17px;
			border: 1px solid black;
			border-radius: 4px;
			margin-left: .5px;
			margin-right: .5px;
		}

	.button-image{
		height: 15px;
	}

	.disabled{
		opacity:0.3;
	}

	@media (hover: hover) {
		.hover:hover{
			background-color: #a6f4e5;
		}
	}

	.selected{
		background-color: #42f545;
		font-weight: bold;
	}

</style>